// Carousel
import Carousel from 'bootstrap/js/dist/carousel';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.carousel[data-bs-ride="false"]').forEach(function (el) {
        // ✅ Initialize without autoplay
        new Carousel(el, {
            interval: false,
            ride: false,
            touch: true,
            wrap: true
        });
    });
});